import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_JOB_STATUS_LIST_QUERY = gql`
  query GetJobStatusList {
    getJobStatusList {
      cloudId
      colour
      name
      orderIndex
      status
      wfDeletedOnUtc
    }
  }
` as import('../../__generated__/ts-gql/GetJobStatusList').type;

export type GetJobStatusListQueryResult = OperationData<
  typeof GET_JOB_STATUS_LIST_QUERY
>;

export type GetJobStatusListResult = NonNullable<
  ReturnType<typeof processData>
>[never];

// type picked = Pick<
//   JobStatusEntity,
//   'cloudId' | 'colour' | 'name' | 'orderIndex' | 'status' | 'wfDeletedOnUtc'
// >;

// type omitted = Omit<picked, 'status' | 'wfDeletedOnUtc'>;

// export type GetJobStatusListResult = omitted & {
//   status?: JobStatus;
//   wfDeletedOnUtc?: Date | null;
// };

export const useGetJobStatusList = (
  options?: QueryHookOptions<GetJobStatusListQueryResult>
) => {
  const res = useQuery(GET_JOB_STATUS_LIST_QUERY, {
    context: { service: 'core' },
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: processData(res.data) }), [res]);
};

export function processData(data: GetJobStatusListQueryResult | undefined) {
  const rawRows = data?.getJobStatusList;
  const result = rawRows?.map((raw) => ({
    ...raw,
    status: raw.status,
    wfDeletedOnUtc: raw.wfDeletedOnUtc && new Date(raw.wfDeletedOnUtc),
  }));
  return result;
}
